<template>
    <div>
        <div class="searchRoot" v-if="Show">
            <div id="navSearch">
                <img @click="toggle" src="@/assets/images/template/a_top_return.png"/>
            </div>
            <div class="search-container">
                <div class="sub-search-wrapper">
                    <input type="text" class="sub-search-bar" v-model="searchText" placeholder="Search..." @keyup.enter="search" @input="search""/>
                </div>
                <img class="sub-search-btn" @click="search" src="@/assets/images/template/a_top_search_result.png"/>
            </div>
            <div class="search-result-container">
                <div class="result-item" v-for="(item,index) in searchResults" :key="index" @click="showQuote(item)">
                    {{item.szShortName}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductListUtil from '@/utils/productListUtil'
    export default {
        name: "QuoteSearch",
        mounted() {
        },
        data() {
            return {
                searchText: "",
                Show: false,
                searchResults: ["test1","test2","test3"],
            }
        },
        methods: {
            search() {
                this.searchResults = ProductListUtil.fuzzySearch(this.searchText);
            },
            toggle(){
                this.Show = !this.Show;
                this.searchText = "";
            },
            show(){
                this.toggle();
                this.search();
            },
            showQuote(item){
                this.toggle();
                this.$router.push({path: '/home/quoteChart',query: {id: item.uiCodeID,index:0}});
            }
        },
    }
</script>
